<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleCadastroProduto"
             color="primary" class="normal-btn-text rounded-tag-small elevation-0"
             link to="/categoria/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Categoria
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque pela descrição da categoria ou código"
                      class="rounded-tag-small" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleCadastroProduto']),
    searchText: {
      get() {
        return this.$store.getters['listagemGrupos/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemGrupos/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter();
    },
    onSelectItem() {
      this.onChangeFilter();
    },
  },
};
</script>
